



































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'

/**
 * Campo de tipo fecha
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class TimeInput extends Vue {
    /**
     * Etiqueta para el nombre del campo
     */
    @Prop({type: String, default: 'Seleccionar hora'})
    public label: string

    @Prop({type: String, default: 'access_time'})
    public prependIcon: string

    @Prop({type: String, default: ''})
    public suffix: string

    @Prop({type: Array, default: () => []})
    public rules: Array<(v: string | any) => any>

    /**
     * Tiempo insertado por el componente padre
     */
    @Prop({type: String, default: ''})
    public value: string

    @Prop({type: String, default: ''})
    public hint: string

    /**
     * Indica si el menu se encuentra activo
     */
    public menuActive = false

    /**
     * Tiempo del TimePicker
     */
    public time = ''

    /**
     * Cuando el tiempo cambio se notifica mediante el event input
     *
     * @param val
     */
    @Watch('time')
    public onTimeChange (val: string) {
        this.$emit('input', val)
    }

    @Watch('value')
    public onValueChange (val: string) {
        this.time = val
    }

    public created () {
        this.time = this.value
    }
}
